import React from 'react'
import ListCreatePost from "./ListCreatePost"
import ListCommunityPost from './ListCommunityPost';
import ListProductSlider from "./ListProductSlider";
import ListJob from "./ListJob";
import ListService from "./ListService"
import AddCreatePost from '../../AddProject/AddProjectPost/AddCreatePost';
export default function ListPostMain() {
  return (
    <>
    <AddCreatePost/>
      <ListCommunityPost/>
      <ListProductSlider/>
      <ListService/>
      <ListJob/>
    </>
  )
}
